import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import LongTermImg1 from '../../assest/Long-1.png';
import LongTermImg2 from '../../assest/Long-2.png';
import LongTermImg3 from '../../assest/Long-3.png';

const longTermList = [
  {
    name: "Monthly Plan",
    image: LongTermImg1,
    specs: "Reliable service for ongoing projects.",
    description: "Perfect for long-term construction or development efforts with consistent needs.",
  },
  {
    name: "Quarterly Plan",
    image: LongTermImg2,
    specs: "Cost-effective and scalable support.",
    description: "Ideal for extended projects requiring steady support over multiple months.",
  },
  {
    name: "Annual Plan",
    image: LongTermImg3,
    specs: "Max value for year-round usage.",
    description: "Designed for major developments, maintenance contracts, and long-term facilities management.",
  },
];

const translations = {
  gb: {
    heading: "Long-Term Services",
    introText: "Choose reliable and cost-effective long-term rental options.",
    categoriesTitle: "Long-Term Options",
    featuredTitle: "Sustainable Rental Plans",
    featuredDescription: "Long-term solutions for projects needing continuity, reliability, and cost efficiency.",
  },
  sa: {
    heading: "الخدمات طويلة الأجل",
    introText: "اختر خيارات إيجار موثوقة وفعالة من حيث التكلفة طويلة الأجل.",
    categoriesTitle: "خيارات طويلة الأجل",
    featuredTitle: "خطط إيجار مستدامة",
    featuredDescription: "حلول طويلة الأجل للمشاريع التي تتطلب الاستمرارية والموثوقية والكفاءة في التكلفة.",
  },
};

const LongTerm = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={longTermList}
      language={language}
    />
  );
};

export default LongTerm;
